<script>
import { get } from 'vuex-pathify'
import groupBy from 'lodash/groupBy'
const Availability = require('#/shop-catalog/services/stock-availability.js')

export default {
	data() {
		return {
			products: [],
			loading: false,
			fetching: false,
			search: '',
			searchFilter: '',
			filterCrucero: false,
			categoryOptions: [],
			loadingSearch: false,
			selectedCategory: null,
			qtyMap: {},
			Availability,
			pointsTotal: 0,
		}
	},
	computed: {
		order: get('cart/order'),
		filteredProducts() {
			let res = this.products.filter((product) => {
				return product.sku.includes('_CRU') ? this.filterCrucero : !this.filterCrucero
			})

			if (this.searchFilter) {
				let words = String(this.searchFilter)
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.split(' ')
					.filter(Boolean)

				if (words?.length) {
					res = res.filter((product) => {
						return words.every((str) => product.searchString.includes(str))
					})
				}
			}

			if (this.selectedCategory) {
				res = res.filter((product) => {
					return product.categories == this.selectedCategory
				})
			}

			// group by categories
			res = groupBy(res || [], 'categories')
			for (let key in res) {
				res[key].sort((a, b) => {
					return (
						Number(a.stock.availability == Availability.OUT_OF_STOCK) -
						Number(b.stock.availability == Availability.OUT_OF_STOCK)
					)
				})
			}
			return Object.entries(res).reduce((acc, entry) => {
				const [categories, products] = entry
				acc.push({ isCategoryLabel: true, categories })
				acc.push(...products)
				return acc
			}, [])
		},
	},
	watch: {
		order: {
			handler() {
				this.setQtyMap()
			},
		},
		search(value) {
			setTimeout(() => {
				if (this.search === value) {
					this.searchFilter = value
					this.toScroll()
				}
			}, 500)
		},
	},
	methods: {
		onBlur(variant, ev) {
			const qty = ev
			const item = this.order?.items.find((item) => item.cartData.variantId == variant.id)

			if (item?.qty == qty) return

			if (!item && qty > 0) {
				this.$shop.addToCart({
					productId: variant.productId,
					variantId: variant.id,
					qty,
					sum: false,
					showCart: false,
					showUpsells: false,
					loading: (v) => (this.loading = v),
				})
				return
			}

			if (item) {
				if (item.qty == qty) return
				if (item.qty > 0 && qty == 0) {
					this.$shop.deleteCartItem({
						cartItemId: item.cartItemId,
						loading: (v) => (this.loading = v),
					})
				} else {
					this.$shop.updateCartItem({
						cartItemId: item.cartItemId,
						qty,
						loading: (v) => (this.loading = v),
					})
				}
			}
		},
		setQtyMap() {
			this.qtyMap = {}
			this.pointsMap = {}
			this.$nextTick(() => {
				let qtyMap = (this.qtyMap =
					this.order?.items.reduce((acc, item) => {
						acc[item.cartData.variantId] = item.qty
						return acc
					}, {}) || {})
				let pointsTotal = this.order?.items.reduce((acc, item) => {
					const variant = this.products.find((v) => v.id == item.cartData.variantId)
					if (variant?.custom?.crucero?.points) {
						acc += variant.custom.crucero.points * item.qty
					}
					return acc
				}, 0)
				this.pointsTotal = pointsTotal || 0
				this.$assign(this.qtyMap, qtyMap)
			})
		},
		toScroll() {
			if (this.$b.mt) return
			window.scrollTo({ top: 112, behavior: 'smooth' })
		},
		getPoints(variant) {
			if (!variant.custom?.crucero?.points) return '-'
			return (variant.custom.crucero.points * this.qtyMap[variant.id] || 0).toLocaleString('es-AR')
		},
	},
	async mounted() {
		await this.$shopApi.get({
			url: '/bulkshop',
			loading: (v) => (this.fetching = v),
			onSuccess: ({ data }) => {
				let categoryOptions = []
				this.products = data.products.flatMap((product) => {
					if (!categoryOptions.includes(product.categories)) categoryOptions.push(product.categories)
					return product.variants.map((variant) => {
						let name = product.name
						if (variant.attrs.length) {
							name += ' - ' + variant.attrs.map((attr) => attr.v).join(' | ')
						}

						let tag = product.tag
						if (variant.sku.includes('_CRU')) {
							tag = 'CRUCERO'
						}

						return {
							name,
							productId: variant.productId,
							tag,
							categories: product.categories,
							urlName: product.urlName,
							image: product.images[0],
							id: variant.id,
							sku: variant.sku,
							pvPrice: variant.pvPrice,
							stock: variant.stock,
							searchString: String(`${name} ${variant.sku}`)
								.toLowerCase()
								.normalize('NFD')
								.replace(/[\u0300-\u036f]/g, ''),
							custom: variant.custom || {},
						}
					})
				})
				this.categoryOptions = categoryOptions
				this.setQtyMap()
			},
		})
	},
}
</script>

<template>
	<Container>
		<div class="px-2 py-4">
			<v-row>
				<v-col cols="12" md="3">
					<TextField
						v-model="search"
						:disabled="fetching"
						outlined
						label="Buscar por SKU o nombre..."
						dense
						clearable
						prepend-icon="mdi-magnify"
					/>
				</v-col>
				<v-col cols="12" md="4">
					<Autocomplete
						:items="categoryOptions"
						v-model="selectedCategory"
						dense
						outlined
						label="Filtrar por categoría..."
						:disable="fetching"
						clearable
						prepend-icon="mdi-filter"
					/>
				</v-col>
				<v-col cols="12" md="5" class="d-flex align-center" style="gap: 4px">
					<Button
						:outlined="!filterCrucero"
						color="primary"
						:style="{ color: filterCrucero ? 'white !important' : '' }"
						@click="filterCrucero = !filterCrucero"
						>CRUCERO</Button
					>
					<div
						v-if="filterCrucero"
						class="flex-grow-1 text-center white h100 d-flex justify-center align-center rounded"
					>
						Total Puntos: {{ pointsTotal.toLocaleString('es-AR') }}
					</div>
				</v-col>
			</v-row>
		</div>
		<div class="overflow-auto" @mouseenter="toScroll()">
			<div class="inline-block">
				<div class="table-container">
					<div class="bulkshop-table" :class="loading && 'loading'">
						<div class="__header">
							<div class="text-center">Código</div>
							<div class="text-center w-70">Tipo</div>
							<div class="__name">Producto</div>
							<div class="text-center">PVP</div>
							<div class="text-center w-110">Precio</div>
							<div v-show="filterCrucero" class="text-center w-50">Puntos</div>
							<div class="text-center">Cantidad</div>
							<div class="text-center">Subtotal</div>
							<div v-show="filterCrucero" class="text-center w-100">Subtotal <b>PTOS</b></div>
						</div>
						<v-virtual-scroll
							:items="filteredProducts"
							height="calc(100vh - 248px)"
							item-height="60"
							width="100%"
							min-width="100%"
							class="__body"
						>
							<template #default="{ item: variant }">
								<div v-if="variant.isCategoryLabel" class="__category-name pl-3">
									{{ variant.categories }}
								</div>
								<div v-else class="__row">
									<div class="__cell">{{ variant.sku }}</div>
									<div class="__cell w-70">{{ variant.tag }}</div>
									<div class="__cell __name">
										<Media class="flex-shrink-0" :src="variant.image.thumb" width="45px" />
										<SafeLink
											:to="{
												name: 'product',
												params: { urlName: variant.urlName, id: variant.productId },
												query: { variant: variant.id },
											}"
											tabindex="-1"
										>
											{{ variant.name }}
											<div
												style="font-size: 11px"
												class="error--text"
												v-if="variant.stock.availability == Availability.OUT_OF_STOCK"
											>
												Producto no disponible en stock
											</div>
										</SafeLink>
									</div>
									<div
										class="__cell __price"
										:class="{
											'--outofstock': variant.stock.availability == Availability.OUT_OF_STOCK,
										}"
									>
										<PriceText
											v-if="variant.pvPrice.prevPrice"
											price-class="grey--text"
											:amount="variant.pvPrice.prevPrice"
											:currency="variant.pvPrice.priceConfig.currency.sign"
										/>
										<div v-else class="grey--text">-</div>
									</div>
									<div
										class="__cell __price w-110"
										:class="{
											'--outofstock': variant.stock.availability == Availability.OUT_OF_STOCK,
										}"
									>
										<PriceText
											:amount="variant.pvPrice.price"
											:currency="variant.pvPrice.priceConfig.currency.sign"
										/>
									</div>
									<div v-show="filterCrucero" class="__cell w-50">
										{{
											variant.custom && variant.custom.crucero
												? variant.custom.crucero.points
												: '-'
										}}
									</div>
									<div
										class="__cell __input"
										:class="{
											'--outofstock': variant.stock.availability == Availability.OUT_OF_STOCK,
										}"
									>
										<Bulkshop-Input :value="qtyMap[variant.id]" @change="onBlur(variant, $event)" />
									</div>
									<div
										class="__cell __price"
										:class="{
											'--outofstock': variant.stock.availability == Availability.OUT_OF_STOCK,
										}"
									>
										<PriceText
											class=""
											:amount="variant.pvPrice.price * qtyMap[variant.id] || 0"
											:currency="variant.pvPrice.priceConfig.currency.sign"
										/>
									</div>
									<div v-show="filterCrucero" class="__cell w-100">{{ getPoints(variant) }}</div>
								</div>
							</template>
						</v-virtual-scroll>
					</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<style scoped lang="scss">
@for $w from 50 through 110 {
	@if ($w % 10 == 0) {
		.w-#{$w} {
			width: #{$w}px !important;
		}
	}
}
@mixin scrollbar {
	scrollbar-width: thin;
	scrollbar-color: var(--primary) var(--secondary);
}
.overflow-auto {
	height: 100%;
	@include scrollbar;
}
.inline-block {
	min-width: 100%;
	display: inline-block;
}
.table-container {
	position: relative;
	width: 1176px;
}
.bulkshop-table {
	background-color: white;
	border-radius: 8px;

	.__header {
		padding: 12px 22px 12px 12px;
		display: flex;
		border-bottom: 1px solid #777;
		gap: 10px;
		div {
			text-align: left;
			flex-shrink: 0;
			width: 120px;

			&.__name {
				width: 100%;
				flex-shrink: 1;
			}
		}
	}
	.__body {
		overflow-x: hidden;

		.__category-name {
			display: flex;
			align-items: center;
			height: 60px;
			background: #666;
			color: white;
			border-bottom: 1px solid #fff;
			font-size: 18px;
			font-weight: 500;
			padding-left: 24px;
		}
		.__row {
			padding-right: 12px;
			padding-left: 12px;
			display: flex;
			border-bottom: 1px solid #777;
			gap: 10px;

			.__cell {
				height: 60px;
				flex-shrink: 0;
				width: 120px;
				display: flex;
				align-items: center;
				justify-content: center;
				&.__input {
				}
				&.__price {
				}
				&.__name {
					line-height: 1.2;
					flex-shrink: 1;
					width: 100%;
					justify-content: flex-start;
					gap: 12px;
				}
			}
		}
		.--outofstock {
			opacity: 0.5;
			pointer-events: none;
		}

		@include scrollbar;
	}
}
.loading {
	pointer-events: none;
	opacity: 0.5;
}
</style>

